export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="14" fill="#1A4D2E" />
    <path d="M24 9c7 5 11 11 11 18a11 11 0 0 1-22 0c0-7 4-13 11-18z" fill="#D4E86A" />
    <g stroke="#14361F" strokeWidth="2" strokeLinecap="round" fill="none">
      <path d="M24 20v13" />
      <path d="M24 23c-3-3-6-3-8-2M24 23c3-3 6-3 8-2" />
      <path d="M22 30l-4 4M26 30l4 4" />
    </g>
    <path d="M13 36L35 14" stroke="#F5F0E6" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <img src="/images/logo-termite-habitat-33.webp" alt="Termite Habitat 33" width="44" height="46" className="w-11 h-11 object-contain shrink-0" />
    <span className="leading-none">
      <span className={`block font-display text-[17px] font-extrabold tracking-tight ${light ? "text-cream" : "text-forest"}`}>
        Moustique<span className="serif-i font-normal text-[19px]"> Bordeaux</span>
      </span>
      <span className={`block text-[10px] font-bold uppercase tracking-[0.2em] mt-1 ${light ? "text-fern" : "text-sage"}`}>
        par Termite Habitat 33
      </span>
    </span>
  </span>
);
